import { render, staticRenderFns } from "./PopIndex.vue?vue&type=template&id=3cc86a72&scoped=true"
import script from "./PopIndex.vue?vue&type=script&lang=js"
export * from "./PopIndex.vue?vue&type=script&lang=js"
import style0 from "./PopIndex.vue?vue&type=style&index=0&id=3cc86a72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc86a72",
  null
  
)

export default component.exports